import { SectionForm } from './SectionForm';
import { useCreateSectionMutation } from '../hooks/useCreateSectionMutation';

export function CreateSectionModal({
  templateId,
  onClose,
}: {
  templateId: number;
  onClose: () => void;
}) {
  const { createSectionMutation, handleSubmit } = useCreateSectionMutation({
    templateId,
    onClose,
  });

  return (
    <SectionForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      isSubmitting={createSectionMutation.isPending}
    />
  );
}
